export const HaircutIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 371.073 371.073"
      fill="currentColor"
      {...props}
    >
      <g xmlns="http://www.w3.org/2000/svg">
        <path d="M275.167,140.556c-25.62,28.65-22,41.092-73.52,53.832c-51.514,12.74-104.755,52.383-112.293,59.904   c-7.52,7.52-2.16,70.763-2.16,70.763s-12.01-14.62-13.896-23.447c4.77,34.868,5.64,54.847,15.63,69.467   c-31.99-16.359-46.732-99.991-54.264-140.662c-7.52-40.637,2.604-69.012,7.806-121.542C47.685,56.34,107.162,9.468,134.078,7.723   c11.741-0.753,34.81-9.563,56.424-7.374c27.914,2.82,53.837,16.926,53.837,16.926s71.184,3.912,88.115,125.459   c27.348,179.272-38.627,200.992-38.627,200.992s18.239-25.176,16.487-34.296c-13.686,10.639-20.832,4.765-20.832,4.765   S334.206,246.479,275.167,140.556z" />
      </g>
    </svg>
  );
};
